export default "__VITE_ASSET__Dgd7MPwM__"